<div class="signin">
  <aside class="signin__brand">
    <span class="signin__hatch" aria-hidden="true"></span>
    <span class="signin__watermark" aria-hidden="true"></span>

    <div class="signin__brand-content">
      <img
        class="signin__logo"
        src="assets/app/img/login/quotiss-logo-white.svg"
        alt="Quotiss"
        width="160"
        height="38"
      />

      <h2 class="signin__pitch">
        <span class="signin__pitch-lead">Turn your commercial process</span>
        <span class="signin__pitch-strong"
          >into an engine for revenue growth.</span
        >
      </h2>

      <ul class="signin__features">
        <li class="signin__feature">
          <span class="signin__feature-icon signin__feature-icon--automate">
            <img
              src="assets/app/img/login/sparkles.svg"
              alt=""
              width="16"
              height="16"
            />
          </span>
          <p>
            <strong>Automating</strong> workflow process, increasing working
            speed and accuracy.
          </p>
        </li>
        <li class="signin__feature">
          <span class="signin__feature-icon signin__feature-icon--analyze">
            <img
              src="assets/app/img/login/chart-bar.svg"
              alt=""
              width="16"
              height="16"
            />
          </span>
          <p>
            <strong>Providing</strong> real-time business intelligence and
            performance analytics.
          </p>
        </li>
        <li class="signin__feature">
          <span class="signin__feature-icon signin__feature-icon--collaborate">
            <img
              src="assets/app/img/login/users.svg"
              alt=""
              width="16"
              height="16"
            />
          </span>
          <p>
            <strong>Improving</strong> collaboration between Sales, Pricing,
            Operations, and Management.
          </p>
        </li>
      </ul>

      <a
        pButton
        class="signin__brand-cta"
        [outlined]="true"
        href="https://quotiss.com"
        target="_blank"
        rel="noopener"
      >
        Back to Quotiss site
      </a>
    </div>
  </aside>

  <section class="signin__panel">
    <span class="signin__hatch signin__hatch--panel" aria-hidden="true"></span>

    <div class="signin__panel-content">
      <div class="signin__support">
        <span>Have a question?</span>
        <a
          pButton
          [outlined]="true"
          href="https://quotiss.com/contact"
          target="_blank"
          rel="noopener"
        >
          Contact us
        </a>
      </div>

      <div class="signin__forms">
        <header class="signin__heading">
          <h1 class="signin__title">{{ heading.title }}</h1>
          @if (heading.subtitle) {
            <p class="signin__subtitle">{{ heading.subtitle }}</p>
          }
        </header>

        <form
          [formGroup]="loginForm"
          (ngSubmit)="logIn()"
          class="signin-form"
          [class.visible]="currentFormType === formType.login"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-login-username">
              Email <span class="signin-field__required">*</span>
            </label>
            <input
              pInputText
              id="e-login-username"
              type="text"
              formControlName="username"
              placeholder="name@example.com"
              autocomplete="username"
            />
            @if (isInvalid(loginForm, "username")) {
              <p-message severity="error" variant="simple" size="small">
                This field is required. Please enter your email address.
              </p-message>
            }
          </div>

          <div class="signin-field">
            <label class="signin-field__label" for="e-login-password">
              Password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-login-password"
                formControlName="password"
                autocomplete="current-password"
                [mask]="masked.login"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.login ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.login = !masked.login"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.login"
                    [class.pi-eye-slash]="!masked.login"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(loginForm, "password")) {
              <p-message severity="error" variant="simple" size="small">
                This field is required. Please enter your password.
              </p-message>
            }
          </div>

          <div class="signin-form__aside">
            <span>Forgot your password?</span>
            <button
              pButton
              [link]="true"
              type="button"
              (click)="switchFormType(formType.requestReset)"
            >
              Reset password
            </button>
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              id="e-login-submit"
              type="submit"
              [loading]="loading"
              [disabled]="loading"
            >
              Sign in <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </form>

        <form
          [formGroup]="twoFactorForm"
          (ngSubmit)="verifyTwoFactor()"
          class="signin-form"
          [class.visible]="currentFormType === formType.twoFactor"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-2fa-code">
              Authentication code <span class="signin-field__required">*</span>
            </label>
            <input
              pInputText
              id="e-2fa-code"
              type="text"
              formControlName="code"
              placeholder="000000"
              maxlength="6"
              pattern="[0-9]*"
              inputmode="numeric"
              autocomplete="one-time-code"
            />
            @if (isInvalid(twoFactorForm, "code")) {
              <p-message severity="error" variant="simple" size="small">
                Please enter the 6-digit code from your authenticator app.
              </p-message>
            }
          </div>

          <div class="signin-form__aside">
            <span>Lost access to your authenticator?</span>
            <button
              pButton
              [link]="true"
              type="button"
              (click)="switchFormType(formType.login)"
            >
              Back to sign in
            </button>
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              id="e-2fa-submit"
              type="submit"
              [loading]="loading"
              [disabled]="loading"
            >
              Verify code <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </form>

        <form
          [formGroup]="resetPasswordRequestForm"
          (ngSubmit)="resetPasswordRequest()"
          class="signin-form"
          [class.visible]="currentFormType === formType.requestReset"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-reset-email">
              Email <span class="signin-field__required">*</span>
            </label>
            <input
              pInputText
              id="e-reset-email"
              type="text"
              formControlName="email"
              placeholder="name@example.com"
              autocomplete="email"
            />
            @if (isInvalid(resetPasswordRequestForm, "email")) {
              <p-message severity="error" variant="simple" size="small">
                This field is required. Please enter a valid email address.
              </p-message>
            }
          </div>

          <div class="signin-form__aside">
            <span>Already have an account?</span>
            <button
              pButton
              [link]="true"
              type="button"
              (click)="switchFormType(formType.login)"
            >
              Sign in
            </button>
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              type="submit"
              [loading]="loading"
              [disabled]="loading"
            >
              Send reset link <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </form>

        <form
          [formGroup]="resetPasswordForm"
          (ngSubmit)="resetPassword()"
          class="signin-form"
          [class.visible]="currentFormType === formType.reset"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-reset-password">
              New password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-reset-password"
                formControlName="password"
                autocomplete="new-password"
                [mask]="masked.reset"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.reset ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.reset = !masked.reset"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.reset"
                    [class.pi-eye-slash]="!masked.reset"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(resetPasswordForm, "password")) {
              <p-message severity="error" variant="simple" size="small">
                {{ passwordRequirements }}
              </p-message>
            }
          </div>

          <div class="signin-field">
            <label class="signin-field__label" for="e-reset-password-confirm">
              Confirm password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-reset-password-confirm"
                formControlName="passwordConfirm"
                autocomplete="new-password"
                [mask]="masked.resetConfirm"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.resetConfirm ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.resetConfirm = !masked.resetConfirm"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.resetConfirm"
                    [class.pi-eye-slash]="!masked.resetConfirm"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(resetPasswordForm, "passwordConfirm")) {
              <p-message severity="error" variant="simple" size="small">
                Please repeat the password.
              </p-message>
            }
          </div>

          <div class="signin-form__aside">
            <span>Already have an account?</span>
            <button
              pButton
              [link]="true"
              type="button"
              (click)="switchFormType(formType.login)"
            >
              Sign in
            </button>
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              type="submit"
              [loading]="loading"
              [disabled]="loading"
            >
              Save password <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </form>

        <form
          [formGroup]="joinForm"
          (ngSubmit)="join()"
          class="signin-form"
          [class.visible]="currentFormType === formType.join"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-join-password">
              Password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-join-password"
                formControlName="password"
                autocomplete="new-password"
                [mask]="masked.join"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.join ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.join = !masked.join"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.join"
                    [class.pi-eye-slash]="!masked.join"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(joinForm, "password")) {
              <p-message severity="error" variant="simple" size="small">
                {{ passwordRequirements }}
              </p-message>
            }
          </div>

          <div class="signin-field">
            <label class="signin-field__label" for="e-join-password-confirm">
              Confirm password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-join-password-confirm"
                formControlName="passwordConfirm"
                autocomplete="new-password"
                [mask]="masked.joinConfirm"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.joinConfirm ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.joinConfirm = !masked.joinConfirm"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.joinConfirm"
                    [class.pi-eye-slash]="!masked.joinConfirm"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(joinForm, "passwordConfirm")) {
              <p-message severity="error" variant="simple" size="small">
                Please repeat the password.
              </p-message>
            }
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              type="submit"
              [loading]="loading"
              [disabled]="loading"
            >
              Join <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </form>

        <form
          [formGroup]="activateForm"
          (ngSubmit)="activate()"
          class="signin-form"
          [class.visible]="currentFormType === formType.activate"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-activate-password">
              Password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-activate-password"
                formControlName="password"
                autocomplete="new-password"
                [mask]="masked.activate"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.activate ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.activate = !masked.activate"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.activate"
                    [class.pi-eye-slash]="!masked.activate"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(activateForm, "password")) {
              <p-message severity="error" variant="simple" size="small">
                {{ passwordRequirements }}
              </p-message>
            }
          </div>

          <div class="signin-field">
            <label
              class="signin-field__label"
              for="e-activate-password-confirm"
            >
              Confirm password <span class="signin-field__required">*</span>
            </label>
            <p-iconfield iconPosition="right">
              <input
                pInputPassword
                id="e-activate-password-confirm"
                formControlName="passwordConfirm"
                autocomplete="new-password"
                [mask]="masked.activateConfirm"
                [fluid]="true"
              />
              <p-inputicon>
                <button
                  type="button"
                  class="signin-field__reveal"
                  [attr.aria-label]="
                    masked.activateConfirm ? 'Show password' : 'Hide password'
                  "
                  (click)="masked.activateConfirm = !masked.activateConfirm"
                >
                  <i
                    class="pi"
                    [class.pi-eye]="masked.activateConfirm"
                    [class.pi-eye-slash]="!masked.activateConfirm"
                  ></i>
                </button>
              </p-inputicon>
            </p-iconfield>
            @if (isInvalid(activateForm, "passwordConfirm")) {
              <p-message severity="error" variant="simple" size="small">
                Please repeat the password.
              </p-message>
            }
          </div>

          <div class="signin-form__terms">
            <p-checkbox
              inputId="e-activate-terms"
              [formControl]="activateForm.controls['termsAgreement']"
              binary="true"
              data-cy="accept"
            ></p-checkbox>
            <label for="e-activate-terms">
              I accept the
              <a
                href="https://quotiss.com/privacy-policy-feb-2018/"
                target="_blank"
                rel="noopener"
                class="signin-link"
              >
                Terms &amp; Conditions
              </a>
            </label>
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              type="submit"
              [loading]="loading"
              [disabled]="loading || !activateForm.get('termsAgreement').value"
            >
              Activate <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </form>

        <form
          [formGroup]="registerForm"
          (ngSubmit)="registerUser()"
          class="signin-form"
          [class.visible]="currentFormType === formType.register"
        >
          <div class="signin-field">
            <label class="signin-field__label" for="e-register-organization">
              Organization name <span class="signin-field__required">*</span>
            </label>
            <input
              pInputText
              id="e-register-organization"
              data-cy="login-org-name"
              type="text"
              formControlName="organizationName"
              placeholder="Organization name"
            />
            @if (isInvalid(registerForm, "organizationName")) {
              <p-message severity="error" variant="simple" size="small">
                This field is required.
              </p-message>
            }
          </div>

          <div class="signin-form__split">
            <div class="signin-field">
              <label class="signin-field__label" for="e-register-first-name">
                First name <span class="signin-field__required">*</span>
              </label>
              <input
                pInputText
                id="e-register-first-name"
                data-cy="login-first-name"
                type="text"
                formControlName="firstName"
                placeholder="First name"
              />
              @if (isInvalid(registerForm, "firstName")) {
                <p-message severity="error" variant="simple" size="small">
                  This field is required.
                </p-message>
              }
            </div>

            <div class="signin-field">
              <label class="signin-field__label" for="e-register-last-name">
                Last name <span class="signin-field__required">*</span>
              </label>
              <input
                pInputText
                id="e-register-last-name"
                data-cy="login-last-name"
                type="text"
                formControlName="lastName"
                placeholder="Last name"
              />
              @if (isInvalid(registerForm, "lastName")) {
                <p-message severity="error" variant="simple" size="small">
                  This field is required.
                </p-message>
              }
            </div>
          </div>

          <div class="signin-field">
            <label class="signin-field__label" for="e-register-email">
              Email <span class="signin-field__required">*</span>
            </label>
            <input
              pInputText
              id="e-register-email"
              data-cy="login-email"
              type="text"
              formControlName="email"
              placeholder="name@example.com"
              autocomplete="email"
            />
            @if (isInvalid(registerForm, "email")) {
              <p-message severity="error" variant="simple" size="small">
                This field is required. Please enter a valid email address.
              </p-message>
            }
          </div>

          <div class="signin-form__aside">
            <span>Already have an account?</span>
            <button
              pButton
              [link]="true"
              type="button"
              (click)="switchFormType(formType.login)"
            >
              Sign in
            </button>
          </div>

          <div class="signin-form__actions">
            <button
              pButton
              data-cy="login-submit"
              type="submit"
              [loading]="loading"
              [disabled]="loading"
              [attr.aria-busy]="loading"
            >
              Create account
              @if (loading) {
                <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
              } @else {
                <i class="pi pi-arrow-right" aria-hidden="true"></i>
              }
            </button>
          </div>
        </form>

        @if (currentFormType === formType.registered) {
          <div class="signin-notice">
            <p>
              Please follow the instructions in the activation email. If it has
              not arrived within 5 minutes, check your spam folder.
            </p>
          </div>
        }

        @if (currentFormType === formType.confirmed) {
          <div class="signin-notice">
            <p>Your account is ready to use.</p>
          </div>
        }

        @if (isSignInVisible()) {
          <div class="signin-form__aside">
            <button
              pButton
              [link]="true"
              type="button"
              (click)="switchFormType(formType.login)"
            >
              Back to sign in
            </button>
          </div>
        }
      </div>
    </div>
  </section>
</div>
